import { PageContainer } from '@/components'
import MailCollectTemplate from './mail-collect-template'

const MailCollect = () => {
  let i
  return (
    <PageContainer>
      <MailCollectTemplate />
    </PageContainer>
  )
}

export default MailCollect
